/**
 * @example declineWordDependingOnCount(1, ['секунд', 'секунда', 'секунды']); // 1 секунда
 * @example declineWordDependingOnCount(2, ['секунд', 'секунда', 'секунды']); // 2 секунды
 * @example declineWordDependingOnCount(5, ['секунд', 'секунда', 'секунды']); // 5 секунд
 */
const declineWordDependingOnCount = (count: number, words: string[]) => {
  let res = ''

  if (count >= 11 && count <= 14) {
    res = words[0]
  } else if (count % 10 === 1 || count % 100 === 1) {
    res = words[1]
  } else if (count % 10 >= 2 && count % 10 <= 4) {
    res = words[2]
  } else {
    res = words[0]
  }

  return res
}

const textUtils = { declineWordDependingOnCount }
export default textUtils
